import { GET_INTERNAL_PHYSICIANS_SUCCESS } from "../actions/physicianAction"

export default (state = {}, { type, data = {} }) => {
  switch (type) {
    case GET_INTERNAL_PHYSICIANS_SUCCESS:
      return data
    default:
      return state
  }
}
